import React from 'react';
import styled from "styled-components";

const SGrammarPreposiciones = styled.div`
  flex: 1;
  padding: 5px 20px;
`;

const GrammarPreposiciones = () => {
  return (
    <SGrammarPreposiciones>
<h5>Preposiciónes - Przyimki</h5>

<p>
W języku hiszpańskim nie istnieje odmiana przez przypadki i w związku z tym przyimki występują tu o wiele częściej niż w języku polskim, ponieważ ich użycie zastępuje tę odmianę. Oprócz przyimków prostych (a, de, con, itd.) w hiszpańskim występują też przyimki złożone (debajo de, antes de, itd.). Poniżej zostało omówione użycie najważniejszych przyimków prostych.
</p>

<h6>Przyimek <i>a</i> określa (<i>a+el=al</i>):</h6>
<li>kierunek bądź przeznaczenie (<i>Llega a Madrid hoy</i> - Dzisiaj przyjeżdża do Madrytu)</li>
<li>położenie (<i>al lado</i> - obok, <i>a la derecha</i> - na prawo, <i>a la izquierda</i> - na lewo, <i>junto a</i> - tuż przy, <i>al norte</i> - na północ, <i>a unos 500 metros</i> - 500 metrów stąd)</li>
<li>częstotliwość (<i>seis veces a la semana</i> - sześć razy w tygodniu)</li>
<li>sposób (<i>a pie</i> - pieszo, <i>a mano</i> - ręcznie, <i>a caballo</i> - konno)</li>
<li>godzinę (<i>Empiezo a las ocho</i> - Zaczynam o ósmej)</li>
<li>cel (<i>Voy a comprar el pan</i> - Mam zamiar kupić chleb)</li>
<li>dopełnienie dalsze (<i>Dale de comer a la nina</i> - Daj obiad dziecku)</li>
<li>dopełnienie bliższe osobowe (<i>He visto a tu marido en la cafetería</i> - Widziałem twojego męża w kawiarni)</li>

<h6>Przyimek <i>con</i> określa:</h6>
<li>obecność innych/towarzystwo (<i>Vive con sus padres</i> - Mieszka z rodzicami)</li>
<li>narzędzie (<i>Lo ha hecho con lápiz y papel</i> - Zrobił to przy pomocy ołówka i papieru)</li>
<li>sposób (<i>Trabaja con mucho interés</i> - Pracuje z dużym zaangażowaniem)</li>

<h6>Przyimek <i>de</i> określa (<i>de+el=del</i>):</h6>
<li>posiadanie (<i>Este coche es de mi hermana</i> - Ten samochód jest mojej siostry)</li>
<li>materiał (<i>Me gustan los helados de fresa</i> - Lubię lody truskawkowe)</li>
<li>początek w czasie i przestrzeni (<i>Trabaja de 8 de la manana</i> - Pracuje od 8 rano / <i>Este café es de Colombia</i> - Ta kawa jest z Kolumbii)</li>
<li>sposób (<i>Siempre estoy de buen humor</i> - Zawsze jestem w dobrym nastroju)</li>
<li>część dnia przy podawaniu godzin (<i>Son las 5 de la tarde</i> - Jest 5 po południu)</li>
<li>miesiąc przy podawaniu dat (<i>Hoy es 12 de mayo</i> - Dzisiaj jest 12 maja)</li>
<li>opis (<i>El hombre de barba es amigo mío</i> - Mężczyzna z brodą jest moim przyjacielem)</li>
<li>typ danego przedmiotu (<i>No me gustan los libros de ciencia ficción</i> - Nie lubię książek SF)</li>

<h6>Przyimek <i>en</i> określa:</h6>
<li>miejsce (<i>Lo vi en la mesa</i> - Widziałem to na stole)</li>
<li>środek transportu (<i>Iré en avión</i> - Polecę salomolotem)</li>
<li>czas (<i>En 1945 terminó la segunda Guerra Mundial</i> - W 1945 skończyła się druga Wojna Światowa / <i>Te doy la contestación en una semana</i> - Dam ci odpowiedź za tydzień)</li>

<h6>Przyimek <i>para</i> określa:</h6>
<li>cel (<i>He venido para ayudar</i> - Przyszedłem, żeby pomóc)</li>
<li>dopełnienie dalsze (<i>Este jersey es para Juan</i> - Ten sweter jest dla Juana)</li>
<li>kierunek (<i>Este tren va para Zaragoza</i> - Ten pociąg jedzie do Zaragozy)</li>
<li>moment w czasie (<i>Necesito estas fotos para el lunes</i> - Potrzebuje te zdjęcia na poniedziałek)</li>

<h6>Przyimek <i>por</i> określa:</h6>
<li>powód (<i>Lo detuvieron por robar en un banco</i> - Zatrzymali go, bo okradł bank)</li>
<li>część dnia (<i>Llega el lunes por la manana</i> - Przyjeżdża w poniedziałek rano)</li>
<li>metodę (<i>Te lo mando por fax</i> - Wysyłam ci to faksem)</li>
<li>cenę (<i>Lo compré por cinco mil pesetas</i> - Kupiłem to za pięć tysięcy peset)</li>
<li>wykonawcę czynności w stronie biernej (<i>"Don Quijote" fue escrito por Cervantes</i> - "Don Quijote" został napisany przez Cervantesa)</li>

<p>
Istnieje dużo czasowników, które mają przyporządkowane konkretne przyimki, i ucząc się ich, najlepiej jest od razu zapamiętywać oba wyrazy, np. <i>sonar con</i> (marzyć o czymś), <i>pensar en</i> (myśleć o czymś), <i>ir a</i> (mieć zamiar coś zrobić).<br/>
Większość przyimków prostych występuje też w przeróżnych utartych zwrotach, z którymi zapoznamy się w odpowiednim czasie. Przyimki złożone najczęściej da się przetłumaczyć na język polski dosłownie.
</p>
    </SGrammarPreposiciones>
  );
};

export default GrammarPreposiciones;